<template>
    <div class="adviser">
        <ul v-for="(item, index) in dataList" :key="index">
            <li class="itemLI">
                <p class="itemLe">订单号：{{item.orderNumber}}</p>
                <div class="itemContent">
                    <div class="itemInfo flex-row m-b-10">
                        <img :src="logo" alt="" class="itemImg">
                        <div class="flex-column">
                            <p class="m-b-10">{{item.salesmanName}}</p>
                            <p class="storeFont">{{item.storeName}}</p>
                        </div>
                        <p>负责人</p>
                        <p>{{item.salesmanPhone}}</p>
                        <img class="itemImg" :src="tel" alt="" @click="viewPhone(item.salesmanPhone)">
                    </div>
                    <div class="itemInfo flex-row">
                        <img :src="logo" alt="" class="itemImg">
                        <div class="flex-column">
                            <p class="m-b-10">{{item.designerName}}</p>
                            <p class="storeFont">{{item.storeName}}</p>
                        </div>
                        <p>设计师</p>
                        <p>{{item.designerPhone}}</p>
                        <img class="itemImg" :src="tel" alt="" @click="viewPhone(item.designerPhone)">
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import { listOrderContacts } from '@/api/index';
import logo  from '@/assets/img/lion.jpg';
import tel  from '@/assets/img/tel.png';
export default {
    data(){
        return{
            dataList: [],
            logo,
            tel
        }
    },
    created(){
        this.getadviser();
    },
    methods:{
        getadviser(){
            let data = this.$loca.getItem('phone');
            let name = this.$loca.getItem('name');
            listOrderContacts({phone: data, name: name}).then(res=>{
                this.dataList = res.data;
            }).catch(error=>{

            })
        },
        viewPhone(item){
             window.location.href = 'tel://' + item;
        },
    }
}
</script>
<style lang="scss" scoped>
    .adviser{
        background: #ededed;
        .itemLI{
            background: #ffffff;
            padding-top: 20px;
            margin-bottom: 20px;
            .itemLe{
                margin-left: 20px;
            }
            .itemContent{
                padding: 20px;
                .itemInfo{
                    border-top: 1px solid #ededed;
                    padding-top: 10px;
                    align-items: center;
                    justify-content: space-around;
                    .itemImg{
                        width: 70px;
                        height: 70px;
                    }
                    .storeFont{
                        color: #909399;
                    }
                }
            }
        }
    }
</style>